<template>
  <div>
    <!-- Criar um componente para exibir as informações do CCG com condição para ser exibido -->
    <div v-if="showDocs === true">
      <tomador-ccgpdf :docs="documentosCCG" />
    </div>

    <div v-if="showDocs === false">
      <div class="tomador__ccg">
        <form-alert
          :type="alertText.type"
          :message="alertText.message"
          @close="closeFormAlert"
        />

        <div>
          <v-card class="card-height">
            <div class="card-height-participantes">
              <v-card-title>Representantes Legais do Tomador</v-card-title>
              <v-card-text>
                <tomador-ccg-representante
                  @click="openModalAddPessoa"
                  @save="openModalAlterarPessoa"
                />
              </v-card-text>

              <v-card-title>Fiadores (Intervenientes Coobrigados)</v-card-title>
              <v-card-text>
                <tomador-ccg-fiadores
                  @click="openModalAddPessoa"
                  @save="openModalAlterarPessoa"
                />
              </v-card-text>
            </div>

            <v-card-actions>
              <div class="box-buttons">
                <button
                  class="button jns-button yellow-button btn-code"
                  v-on:click="changeRepresentatives"
                  :disabled="!podeAssinar()"
                >
                  Solicitar Alterações de Representantes/Fiadores
                </button>

                <button
                  class="button jns-button yellow-button btn-code"
                  @click="signCCG()"
                  :disabled="!podeAssinar()"
                >
                  Assinar CCG
                </button>
              </div>
            </v-card-actions>
          </v-card>
        </div>

        <v-dialog v-model="adicionarPessoasModal" persistent width="60vw">
          <base-modal>
            <tomador-ccg-adicionar-pessoa-modal
              v-if="adicionarPessoasModal"
              :id-tomador="idTomador"
              :pessoa="pessoa"
              :categoria="categoriaParametroModalAdicionar"
              :pai="pai"
              :key="JSON.stringify(pessoa)"
              @close="adicionarPessoasModal = false"
              @save="saveHandler"
              @error="errorHandler"
            />
          </base-modal>
        </v-dialog>

        <v-dialog v-model="alterarPessoaModal" persistent width="60vw">
          <base-modal>
            <tomador-ccg-alterar-pessoa-modal
              v-if="alterarPessoaModal"
              :id-tomador="idTomador"
              :id_pessoa="id_pessoa"
              :documento_pessoa="documento_pessoa"
              :nome_pessoa="nome_pessoa"
              :email_pessoa="email_pessoa"
              :tipo_pessoa="tipo_pessoa"
              :categoria="categoria"
              :key="JSON.stringify(pessoa)"
              @close="alterarPessoaModal = false"
              @save="saveHandlerAlter"
              @error="errorHandlerAlter"
            />
          </base-modal>
        </v-dialog>

        <v-dialog v-model="formSelecionado" max-width="1100" width="720" max-height="700">
          <v-card class="box-dialog-pipefy">
            <div class="box-frame">
              <iframe class="frame" frameborder="0"></iframe>
            </div>

            <v-divider></v-divider>

            <v-card-actions class="box-btn">
              <button
                class="btn-code button jns-button yellow-button"
                v-on:click="closeModal"
              >
                Fechar
              </button>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";
import { mapActions } from "vuex";
export default {
  name: "TomadorCCG",
  mixins: [ViewMixin],
  props: ["idTomador", "documentosCcg"],
  data() {
    return {
      adicionarPessoasModal: false,
      alterarPessoaModal: false,
      editarPessoasModal: false,
      pessoa: false,
      categoriaParametroModalAdicionar: false,
      pai: false,
      id_pessoa: "",
      documento_pessoa: "",
      nome_pessoa: "",
      email_pessoa: "",
      tipo_pessoa: "",
      documentosCCG: "",
      showDocs: false,
      formSelecionado: false,
      urlPipefy: "",
    };
  },
  created(){
    this.documentosCCG = this.documentosCcg;
    this.showDocumentCCG();
    this.getUrlPipefy();
  },
  methods: {
    // ...mapActions('ccg/SIGN_CCG'),
    openModalAddPessoa(data) {
      if (data.pessoa == null) this.pessoa = [];
      else this.pessoa = data.pessoa;

      if (data.pai == null) this.pai = [];
      else this.pai = data.pai;

      this.categoriaParametroModalAdicionar = data.categoria;
      this.adicionarPessoasModal = true;
    },

    openModalAlterarPessoa(data) {
      this.id_pessoa = data.id_pessoa;
      this.documento_pessoa = data.documento_pessoa;
      this.nome_pessoa = data.nome_pessoa;
      this.email_pessoa = data.email_pessoa;
      this.tipo_pessoa = data.tipo_pessoa;
      this.categoria = data.categoria;
      this.alterarPessoaModal = true;
    },

    saveHandler(data, pessoa) {
      pessoa = false;
      this.pessoa = false;
      let message = `${data.tipoPessoaInserir} inserido com sucesso!`;
      this.alertText = this.handleAlertText2(message);
    },

    errorHandler(data) {
      this.alertText = this.handleAlertText2(
        `Houve um problema ao inserir!`,
        "error"
      );
    },

    saveHandlerAlter(data) {
      let message = `${data.tipoPessoaInserir} alterado com sucesso!`;
      this.alertText = this.handleAlertText2(message);
    },

    errorHandlerAlter(data) {
      this.alertText = this.handleAlertText2(
        `Houve um problema ao alterar!`,
        "error"
      );
    },

    modalAvisoPessoas(message) {
      this.$store.commit("SET_ALERT_TEXT", {
        type: "error",
        message: message,
      });
      this.alertText = this.handleAlertText();
    },

    podeAssinar() {
      let pessoas = this.$store.state.ccg.ccg;
      return (
        pessoas.representantes_legais.length > 0 || pessoas.fiadores.length > 0
      );
    },

    changeRepresentatives(){
      //Não salvar pois o form é de produção
      let url = this.urlPipefy;
      var iframe = document.getElementsByTagName("iframe")[0];
      if (iframe) iframe.src = url;

      this.formSelecionado = true;
    },

    closeModal(){
      this.formSelecionado = false
    },

    async getUrlPipefy() {
      try {
        this.urlPipefy = await this.$store.dispatch("GET_PARAMS_PIPEFY");
      } catch (e) {
        console.warn(e);
      } finally {
      }
    },

    async signCCG() {
      let pessoas = this.$store.state.ccg.ccg;
      if (
        pessoas.representantes_legais.length == 0 &&
        pessoas.fiadores.length == 0
      ) {
        this.modalAvisoPessoas(
          "Tomador precisa de ao menos um representante ou fiador!"
        );
      } else {
        if (
          pessoas.representantes_legais.length > 0 &&
          pessoas.representantes_legais.filter(verificaEmailPreenchido).length >
            0
        ) {
          this.modalAvisoPessoas(
            "É necessário que todos os e-mails de representantes estejam preenchidos."
          );
        } else if (
          pessoas.fiadores.length > 0 &&
          pessoas.fiadores.filter(verificaEmailPreenchido).length > 0
        ) {
          this.modalAvisoPessoas(
            "É necessário que todos os e-mails de fiadores estejam preenchidos."
          );
        } else {
          let temFiadorSemRepresentante = false;
          let fiadores = pessoas.fiadores;

          fiadores.forEach((fiador) => {
            if (
              fiador.tipo_pessoa == "JURIDICA" &&
              fiador.representantes.length == 0
            ) {
              temFiadorSemRepresentante = true;
            }
          });

          if (temFiadorSemRepresentante) {
            this.modalAvisoPessoas(
              "Existem fiadores jurídicos sem representantes!"
            );
          } else {
            let temPessoaFisicaSemEmail = false;

            if (pessoas.representantes_legais.length > 0)
              pessoas.representantes_legais.forEach((pessoa) => {
                if (pessoa.tipo_pessoa == "FISICA" && pessoa.email == null) {
                  temPessoaFisicaSemEmail = true;
                }

                if (!temPessoaFisicaSemEmail && pessoa.conjuge != null) {
                  if (
                    pessoa.conjuge.tipo_pessoa == "FISICA" &&
                    pessoa.conjuge.email == null
                  ) {
                    temPessoaFisicaSemEmail = true;
                  }
                }
              });

            if (pessoas.fiadores.length > 0)
              pessoas.fiadores.forEach((pessoa) => {
                if (pessoa.tipo_pessoa == "FISICA" && pessoa.email == null) {
                  temPessoaFisicaSemEmail = true;
                }

                if (!temPessoaFisicaSemEmail && pessoa.conjuge != null) {
                  if (
                    pessoa.conjuge.tipo_pessoa == "FISICA" &&
                    pessoa.conjuge.email == null
                  ) {
                    temPessoaFisicaSemEmail = true;
                  }
                }
              });

            if (temPessoaFisicaSemEmail) {
              this.modalAvisoPessoas(
                "É necessário que todos os e-mails estejam preenchidos."
              );
            } else {
              this.showLoadingIndicator();
              try {
                await this.$store.dispatch("SIGN_CCG", {
                  documento: this.idTomador,
                });
                this.alertText = this.handleAlertText2(
                  "Solicitação realizada com sucesso, em breve todos os representantes legais receberão o documento para assinatura."
                );
              } catch (e) {
                this.defaultHandlerError(e);
              } finally {
                this.hideLoadingIndicator();
              }
            }
          }
        }
      }
    },

    showDocumentCCG(){
      if(this.documentosCCG.length === 0 || this.documentosCCG == [] ){
        this.showDocs = false;
      }else {
        this.showDocs = true;
      }
    },
  },
};

function verificaEmailPreenchido(item) {
  return !item.email && item.tipo_pessoa == "FISICA";
}
</script>

<style lang="scss" scoped>
.tomador__ccg /deep/ .v-card__title {
  background-color: #efefef;
  font-size: 14px;
  font-weight: bolder;
  color: #191737;
  margin-bottom: 20px;
}
.tomador__ccg /deep/ .proposta__blue-text {
  color: #282498;
  font-weight: bold;
  text-decoration: none;

  i {
    color: #282498;
    text-decoration: none;
    margin-right: 8px;
    text-decoration: none;
  }
  &:hover {
    cursor: pointer;
    text-decoration: none;

    i {
      text-decoration: none;
    }
  }
}

.box-buttons {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 2%;

  .btn-code {
    width: 30% !important;
  }
}

@media screen and (max-width: 900px) {
  .box-buttons {
    display: flex;

    .btn-code {
      width: 40% !important;
    }
  }
}

@media screen and (max-width: 700px) {
  .box-buttons {
    display: flex;
    flex-direction: column;

    .btn-code {
      width: 100% !important;
    }
  }

  button:first-child {
    margin-bottom: 2%;
  }
}

.card-height .card-height-participantes {
  max-height: 60vh;
  overflow: auto;
}

.box-dialog-pipefy {
  margin: 1% auto;

  .box-frame {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 1%;

    .frame {
      width: 100%;
      height: 560px;
    }
  }
}

.box-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .btn-code {
    width: 40% !important;
  }
}

@media screen and (max-width: 600px) {
  .box-btn {
    .btn-code {
      width: 100% !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/components/TomadorCCG.vue